import React from 'react';
import Hdr from './shared/Hdr';
import Progress from './Progress';
import { useState, useEffect, useRef } from 'react';
import swal from 'sweetalert';
import { apiPath } from "../src/services/apiConfig";

function Treatments() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const [displayTreatment, setDisplayTreatment] = useState('none');
  const [displayUpdTreatment, setDisplayUpdTreatment] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [verfied, setVerfied] = useState(true);
  const [id, setID] = useState('');
  //  const [Err, SetErr] = useState([]);
  const handleSubmit = () => {

    verifyTreatment()
    if (verfied) {
      formRef.current.reset();
    }
  }
  const formRef = useRef();
  // const [doctorSpecilation, setDoctorSpecialisation] = useState();
  const [serial, setSerial] = useState('');
  //  const [specialityDataStat, setSpecialityDataStat] = useState('')
  const [shortDesc, setShortDesc] = useState('');
  //  const [longDesc, setLongDesc] = useState('');
  //  const [specialityData, setSpecialityData] = useState([])
  //  const [updSpecialitiy, setUpdSpeciality] = useState()
  //  const [defaultSpeciality, setDefaultSpeciality] = useState('1')
  const [isloading, setIsLoading] = useState(false)
  //  const [iconpath, setIconPath] = useState()
  const [updSerial, setUpdSerial] = useState()
  const [updShortDesc, setUpdShortDesc] = useState()
  //  const [updLongDesc, setUpdLongDesc] = useState()
  const [filteredID, setFilteredId] = useState()
  const [deptDatastat, setDeptDataStat] = useState()
  const [deptData, setDeptData] = useState([])
  const [introConclusionStat, setIntroConclusionStat] = useState()
  const [introConclusionData, setIntroConclusionData] = useState()
  const [updIntro, setUpdIntro] = useState('')
  const [updConclusion, setUpdConclusion] = useState('')
  const [dataExist, setDateExist] = useState(false)
  const [updId, setUpdId] = useState(0)

  let txt = "";

  useEffect(() => {
    getDepartment()
  }, [])

  function openTreatment() {
    setDisplayTreatment('block')
  }

  function closeTreatment() {
    formRef.current.reset();
    setDisplayTreatment('none')
  }

  function openUpdTreatment() {
    setDisplayUpdTreatment('block')
  }

  function closeUpdTreatment() {
    setDisplayUpdTreatment('none')
  }

  async function updateTreatment(id) {
    //  alert(id+','+filteredID+","+updSerial+", "+updShortDesc)

    let result = await fetch(apiPath + "updateDeptTreatment", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "department_id": filteredID,
        "srl": updSerial,
        "short_desc": updShortDesc
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)
    getTreatment(filteredID)
  }

  async function deleteTreatment(id, sp_id) {

    let result = await fetch(apiPath + "deleteDeptTreatment/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getTreatment(filteredID)
  }

  async function updateOperation(id) {
    let result = await fetch(apiPath + "getOneDeptTreatment/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdSerial(result.data[0].srl);
    setUpdShortDesc(result.data[0].short_desc)
    setID(result.data[0].id)

    openUpdTreatment();
  }


  function deleteOperation(id, sp_id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          deleteTreatment(id, sp_id);
        }
        else {
          swal("Your record is safe!");
        }
      });
  }


  //* LIST OF ALL TREATMENTS (for initial screen)*/ 

  async function getTreatment(id) {
    let result = await fetch(apiPath + "getTreatmentByDepartment/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result = await result.json();
    setDataStat(result.success);
    setData(result.data);
    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  function verifyTreatment() {
    setVerfied(true)
    addTreatment()
  }

  //*ADD A NEW TREATMENT*/ 
  async function addTreatment() {

    if (verfied) {
      setIsLoading(true)
      let result = await fetch(apiPath + "storeDeptTreatment", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "department_id": filteredID,
          "srl": serial,
          "short_desc": shortDesc,
        })
      });
      result = await result.json();

      //     if (result.success) { }
      //     else {
      //       SetErr(result.data);
      //     }

      showSwal(result.success, result.message)

      getTreatment(filteredID)

      if (isloading) {
      } else {
        setIsLoading(false)
      }
    }
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  //* LIST OF ALL DEPARTMENMT (for combo)*/ 

  async function getDepartment() {
    let result = await fetch(apiPath + "departments",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    setDeptDataStat(result.success);
    setDeptData(result.data);

    if (result.success === true) {
      setDeptData(result.data);
    } else { setDeptData([]) }
  }

  function FilterData(id) {
    setFilteredId(id)
  }

  function FindTreatment() {
    getTreatIntroConclusion(filteredID)
    getTreatment(filteredID)
  }



  async function getTreatIntroConclusion(id) {
    //  alert(id)
    let result2 = await fetch(apiPath + "getTreatmentIntroByDepartment/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })

    result2 = await result2.json();
    setIntroConclusionStat(result2.success);
    //  setSpecialityData(result2.data);
    if (result2.success === true) {

      if (result2.message === 'No record found') {
        setDateExist(false)
        setIntroConclusionData([])
        setUpdIntro('')
        setUpdConclusion('')
        setUpdId(0)
      }
      else {
        setIntroConclusionData(result2.data);
        setUpdIntro(result2.data[0].intro)
        setUpdId(result2.data[0].id)
        setUpdConclusion(result2.data[0].conclusion)
        setDateExist(true)
      }
    } else {
      alert('error in getTreatIntroConclusion ' + result2.message + ' ' + result2.success + ' Dept Id: ' + id)

    }
  }

  async function AddIntroConclusion() {
    alert(filteredID + ', ' + updIntro + ', ' + updConclusion)
    let result = await fetch(apiPath + "storeDeptTreatIntroConclusion", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "department_id": filteredID,
        "intro": updIntro,
        "conclusion": updConclusion,
      })
    });
    result = await result.json();

    if (result.success) {
      setUpdIntro('')
      setUpdConclusion('')
    }
    else {
      //       SetErr(result.data);
    }

    showSwal(result.success, result.message)
  }

  async function UpdateIntroConclusion() {
    alert(updId + ',...' + filteredID + ', ' + updIntro + ', ' + updConclusion)
    let result = await fetch(apiPath + "updateDeptTreatIntroConclusion", {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": updId,
        "department_id": filteredID,
        "intro": updIntro,
        "conclusion": updConclusion,
      })
    });
    result = await result.json();
    //  console.warn(result)

    if (result.success) {
      setUpdIntro('')
      setUpdConclusion('')
    }
    else {
      //        SetErr(result.data);
    }

    showSwal(result.success, result.message)
    setDataStat(false)
  }


  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user} </h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">User : ({usrRole})</p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>

          <div className="row p16">
            <div className="c12-l-3">
              <h4 className="wide">Treatment</h4>
            </div>
            <div className="c12-l-5"></div>
            <div className="c12-l-2">
              <select className="custom-select" onChange={(e) => FilterData(e.target.value)}>
                {
                  (deptDatastat === true ?
                    (
                      deptData.map((item2, index) =>
                        <option value={item2.id}>{item2.name}</option>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </select>
            </div>

            <div className="c12-l-1">
              <button onClick={FindTreatment} type="button" name="button"
                className="btn solid round">Find Treatment</button>
            </div>
            <div className="c12-l-1">
              {dataExist === true ? (
                <div>
                  <button onClick={openTreatment} type="button" name="button"
                    className="btn solid round">Add Treatment</button>
                </div>
              ) : (
                <div>
                </div>
              )}
            </div>
          </div>

          <div className="row mt16" >
            <div className="c12-l-1"></div>
            <div className="c12-l-1">Introduction</div>
            <div className="c12-l-9">
              <textarea className="box small"
                placeholder="Introduction" onChange={(e) => setUpdIntro(e.target.value)}
                value={updIntro} />
            </div>
            <div className="c12-l-1"></div>
            <div className="c12-l-1"></div>
            <div className="c12-l-1">Conclusion</div>
            <div className="c12-l-9">
              <textarea className="box small"
                placeholder="Conclusion" onChange={(e) => setUpdConclusion(e.target.value)}
                value={updConclusion} />
            </div>
            <div className="c12-l-1">

              {dataExist === true ? (
                <div>
                  <button onClick={UpdateIntroConclusion} type="button" name="button"
                    className="btn solid round">Update</button>
                </div>
              ) : (
                <div>
                  <input type="hidden" value={updId} />

                  <button onClick={AddIntroConclusion} type="button" name="button"
                    className="btn solid round">Add Intro-conclution</button>
                </div>
              )}

            </div>
          </div>

          <div className="row mt16" >
            <table style={{ 'height': '100%', 'width': '100%', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
              <thead>
                <tr>
                  <th className="th-border center" width="15%">Id</th>
                  <th className="th-border center" width="15%">Srl</th>
                  <th className="th-border center" width="27%">Icon</th>
                  <th className="th-border left" width="45%">Short Desc</th>
                  <th className="th-border left" width="15%">Edit</th>
                  <th className="th-border left" width="15%">Delete</th>
                </tr>
              </thead>
              <tbody >
                {
                  (dataStat === true ?
                    (
                      data.map((item, index) =>
                        <tr className="tr-border" key={index}>
                          <td className="center">{item.id}</td>
                          <td className="center">{item.srl}</td>
                          <td className="center"><img src={`https://adshospital.site${item.icon}`} width={25} height={25} alt=''></img></td>
                          <td className="left">{item.short_desc}</td>
                          <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                          <td onClick={() => { deleteOperation(item.id, { filteredID }) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                        </tr>
                      ))
                    : <tr><td>No data</td></tr>)
                }
              </tbody>
            </table>
          </div>

          {/* SCREEN FROM ADDING NEW TREATMENT */}

          <div id="newdept" style={{ 'display': displayTreatment }} className="cont__new-dept">
            <form className="" action="" method="" ref={formRef}>
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeTreatment}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add a Treatment</h2>
                  <br></br>

                  <input type="hidden" value={filteredID} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Serial" onChange={(e) => setSerial(e.target.value)} />

                  <textarea className="box small" autoComplete="off" rows='10'
                    placeholder="Short Description" onChange={(e) => setShortDesc(e.target.value)} />

                  <br></br>
                  <button onClick={handleSubmit} type="button"
                    className="btn solid round">Add Treatment</button>

                  {
                    (isloading === true ?

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '5px'
                      }}><Progress /></div>
                      :
                      <div></div>
                    )
                  }
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING TREATMENT */}

          <div id="newdept" style={{ 'display': displayUpdTreatment }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdTreatment}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit Treatment</h2><br /><br />

                  <input type="text" value={id} />
                  <input type="text" className="box small"
                    placeholder="Serial" onChange={(e) => setUpdSerial(e.target.value)}
                    value={updSerial} />

                  <input type="text" className="box small"
                    placeholder="Short Description" onChange={(e) => setUpdShortDesc(e.target.value)}
                    value={updShortDesc} />

                  <br></br>
                  <button onClick={() => { updateTreatment(id) }} type="button"
                    className="btn solid round">Update Treatment</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Treatments;
